import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

type Props = {
	projectName: string;
	projectImg?: string;
	projectDesc: string[];
	projectNote?: string;
	projectLink?: string;
};

export const ProjectCard: React.FC<Props> = ({
	projectName,
	projectImg,
	projectDesc,
	projectNote,
	projectLink

}) => {
	return (
		<div className="relative flex flex-col sm:flex-row bg-coolGray-700/60 border border-coolGray-600 hover:border-coolGray-400 transition rounded-lg p-4 h-full max-[700px]:h-auto max-[700px]:max-h-[220px]">
			{projectImg && (
				<img
					src={projectImg}
					alt={projectName}
					className="w-28 h-28 object-contain rounded-md shrink-0 mb-4 sm:mb-0 sm:mr-4"
				/>
			)}

			<div className="flex flex-col flex-1 pr-6 min-h-0">
				<div className="flex-1 space-y-2">
					<h3 className="text-xl max-[700px]:text-base text-coolGray-100 font-semibold">
						{projectName}
					</h3>

					<ul className="list-disc list-inside text-sm max-[700px]:hidden text-coolGray-200">
						{projectDesc.map((d) => (
							<li key={d}>{d}</li>
						))}
					</ul>

					{projectNote && (
						<p className="text-xs text-coolGray-300 italic max-[700px]:hidden">{projectNote}</p>
					)}
				</div>
			</div>

			{/* bottom-right icon */}
			{projectLink && (
				<a
					href={projectLink}
					target="_blank"
					rel="noopener noreferrer"
					className="absolute bottom-3 right-3 text-coolGray-300 hover:text-white transition"
				>
					<FontAwesomeIcon icon={faUpRightFromSquare} size="lg" />
				</a>
			)}
		</div>
	);
};
